import { addHours, format } from "date-fns";

// import i18next from "i18next";
import i18n, { importLangResources } from "locale";
import moment from "dayjs";

importLangResources("timestamp");

export function timeSince(date) {
  var seconds = Math.floor(new Date().getTime() / 1000 - date),
    interval = Math.floor(seconds / 31536000);

  if (interval > 1) return interval + " " + i18n.t("timestamp:years_ago");

  interval = Math.floor(seconds / 2592000);
  if (interval > 1) return interval + " " + i18n.t("timestamp:months_ago");

  interval = Math.floor(seconds / 86400);
  if (interval >= 1) return interval + " " + i18n.t("timestamp:days_ago");

  interval = Math.floor(seconds / 3600);
  if (interval >= 1) return interval + " " + i18n.t("timestamp:hours_ago");

  interval = Math.floor(seconds / 60);
  if (interval > 1) return interval + " " + i18n.t("timestamp:minutes_ago");

  return Math.floor(seconds) + " " + i18n.t("timestamp:seconds_ago");
}

export function n(n) {
  return n > 9 ? "" + n : "0" + n;
}

export const getCurrentDate = (FORMAT, plusHours = 0) => {
  return format(addHours(new Date(), plusHours), FORMAT);
};

export const getCurrentTime = () => {
  const today = new Date();
  const hour = today.getHours();
  const minutes = today.getMinutes();

  return n(hour) + ":" + n(minutes);
};

const isToday = someDate => {
  const today = new Date();

  return (
    someDate?.getDate() === today?.getDate() &&
    someDate?.getMonth() === today?.getMonth() &&
    someDate?.getFullYear() === today?.getFullYear()
  );
};

const isThisYear = someDate => {
  const today = new Date();

  return someDate?.getFullYear() === today?.getFullYear();
};

export const getTimezone = (date, short = false) => {
  const offset = date.getTimezoneOffset();
  const sign = offset < 0 ? "+" : "-";

  const timezone = !short
    ? `(GMT${sign}${n(Math.abs(offset / 60))}:00)`
    : `GMT${sign}${n(Math.abs(offset / 60))}`;
  return timezone;
};
export const getDateFromTimestamp = (timestamp, locale) => {
  const date = new Date(timestamp * 1000);
  const formattedDate = moment(date).format(locale);
  return formattedDate;
};
export const getShortDateFromTimestamp = timestamp => {
  const date = new Date(timestamp * 1000);

  if (isToday(date)) {
    return `${n(date.getHours())}:${n(date.getMinutes())}`;
  }

  if (isThisYear(date)) {
    const months = i18n.t("timestamp:months", { returnObjects: true });
    return `${months[date.getMonth()]} ${n(date.getDate())}`;
  }

  const options = {
    year: "numeric",
    month: "long",
    day: "numeric"
  };

  return date.toLocaleDateString(i18n.t("timestamp:code"), options);
};

export const getDateByTimestamp = (
  time,
  showWeekday = true,
  shortTimezone = false
) => {
  const date = new Date(time * 1000);
  const timezone = getTimezone(date, shortTimezone);

  const options = {
    year: "numeric",
    month: "long",
    day: "numeric"
  };

  if (showWeekday) {
    options.weekday = "long";
  }

  return `${date.toLocaleDateString(
    i18n.t("timestamp:code"),
    options
  )} ${date.toLocaleTimeString(i18n.t("timestamp:code"), {
    hour: "2-digit",
    minute: "2-digit"
  })} ${timezone}`;
};

export const getLocalDate = (date, showTime = true) => {
  const locale =
    i18n.t("timestamp:code") === "timestamp:code"
      ? "en-US"
      : i18n.t("timestamp:code");

  const options = {
    year: "numeric",
    month: "short",
    day: "numeric"
  };

  return `${date.toLocaleDateString(locale, options)} ${
    showTime
      ? date.toLocaleTimeString(locale, {
          hour: "2-digit",
          minute: "2-digit"
        })
      : ""
  }`;
};

export const getLocalTime = date => {
  const locale =
    i18n.t("timestamp:code") === "timestamp:code"
      ? "en-US"
      : i18n.t("timestamp:code");

  return date.toLocaleTimeString(locale, {
    hour: "2-digit",
    minute: "2-digit"
  });
};

export const getLocalDateByTimestamp = time => {
  const date = new Date(time * 1000);

  if (isToday(date)) {
    return `${getShortDateFromTimestamp(time)} (${timeSince(time)})`;
  }
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric"
  };

  return `${date.toLocaleDateString(
    i18n.t("timestamp:code"),
    options
  )} ${date.toLocaleTimeString(i18n.t("timestamp:code"), {
    hour: "2-digit",
    minute: "2-digit"
  })} (${timeSince(time)})`;
};

export const roundNearestHour = (date, addMinutes = 0) => {
  date.setHours(date.getHours() + Math.round(date.getMinutes() / 60));
  date.setMinutes(addMinutes, 0, 0);
  return date;
};
